import EditBundle from './edit_bundle';

export default EditBundle;
